import api from "./api";

export const callService = {
  initiateCall: async (calleeId, binId) => {
    const response = await api.post("/calls/initiate", { calleeId, binId });
    return response.data;
  },

  acceptCall: async (callId) => {
    const response = await api.post(`/calls/${callId}/accept`);
    return response.data;
  },

  rejectCall: async (callId) => {
    const response = await api.post(`/calls/${callId}/reject`);
    return response.data;
  },

  endCall: async (callId) => {
    const response = await api.post(`/calls/${callId}/end`);
    return response.data;
  },
};
